let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bZcK1")).then(() => parcelRequire('awtPQ'));